import { useState } from 'react';
import { useNotificationProvider } from 'hooks';
import handleMenuData from '../libs/handleMenuData';
import updateSavingData from '../libs/updateSavingData';
import { initData, initIsUpdated } from '../data';

/**
 * @function useSavingMenu
 * @param { function } onUpdateMenu
 * @returns { object }
 */
function useSavingMenu(onUpdateMenu) {
	const { notifySuccess, notifyError } = useNotificationProvider();

	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(initData);
	const [isUpdated, setIsUpdated] = useState(initIsUpdated);

	/**
	 * @function onData
	 * @param { string } type
	 * @param { boolean } progress
	 * @param { string } groupId
	 * @param { object } newData
	 */
	const onData = (type, progress, groupId, newData) => {
		const results = handleMenuData(type, progress, groupId, newData, data);
		setData({ ...results });
	};

	/**
	 * @function onUpdate
	 * @param { string } type
	 * @param { boolean } status
	 */
	const onUpdate = (type, status) => {
		setIsUpdated((prev) => ({ ...prev, [type]: status }));
	};

	const onSave = async () => {
		try {
			setLoading(true);
			updateSavingData(data);
			onUpdateMenu(data);
			onReset();
			notifySuccess();
		} catch (error) {
			notifyError(error.message);
		} finally {
			setLoading(false);
		}
	};

	const onReset = () => setData(initData);

	const onResetForUpdated = () => setIsUpdated(initIsUpdated);

	const savingState = { loading, data, isUpdated };

	const savingHandler = { onData, onSave, onReset, onUpdate, onResetForUpdated };

	return { savingState, savingHandler };
}

export default useSavingMenu;
